<template>
    <div>
        <div class="t-docs">
                <div class="t-docs__container">
                    <div class="t-docs__item">
                        <div class="t-docs__image">
                            <a :href="link"><img src="https://www.elmeh.ru/upload/Sections_/Логотипы/pdf_logo.png"></a>
                        </div>
                        <div class="t-docs__info">
                            <div class="t-docs__name">
                                <a :href="link">{{fullname}}</a>
                            </div>
                            <div class="t-docs__description">
                            </div>
                            <div class="t-docs__cakt">
                                {{cakt}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </div>
</template>

<script>
export default {
    props: {
        fullname: String,
        cakt: String,
        link: String
    }
}
</script>